import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

// eslint-disable-next-line import/prefer-default-export
export const sendEvent = (category, action, label) => {
    trackCustomEvent({
        category,
        action,
        label,
    });
};
